import React from 'react';
import classNames from 'classnames';
import { Link } from '../Link';
import './AlphabeticalColumnsButton.scss';

interface Props {
  to: string;
  children: string;
  unavailable?: boolean;
}

export const AlphabeticalColumnsButton: React.FC<Props> = ({
  to,
  children,
  unavailable = false
}) => {
  return (
    <Link
      className={classNames('AlphabeticalColumnsButton', {
        'AlphabeticalColumnsButton--unavailable': unavailable
      })}
      to={to}
    >
      <span>{children}</span>
    </Link>
  );
};
